exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.tab-item[data-v-a916f242] {\n    padding: 16px;\n}\n.tab-item h3[data-v-a916f242] {\n    border-bottom: 1px solid #999;\n}\n.tab-item p[data-v-a916f242] {\n    margin: 10px 5px;\n}\n", ""]);

